/** Shared ITR source → form → starting price guide (home snapshot + full ITR page).
 * `payment` maps each row to GET .../payment-config/public?entity_type&value&filter
 */
export const SOURCE_ITR_PRICING_GUIDE = [
  {
    source: 'Salary',
    itr: 'Usually ITR-1',
    price: 'Price on request',
    docs: 'PAN, Aadhaar, Form 16, bank interest details',
    payment: { entity_type: 'INCOME_TAX', value: 'SALARY', filter: 'NULL_RETURNS' },
    paymentVariants: [
      { entity_type: 'INCOME_TAX', value: 'SALARY', filter: 'NULL_RETURNS', label: 'null return' },
      { entity_type: 'INCOME_TAX', value: 'SALARY', filter: 'NOT_NULL_RETURNS', label: 'not null returns' },
    ],
  },
  {
    source: 'Business',
    itr: 'Usually ITR-3',
    price: 'Price on request',
    docs: 'PAN, Aadhaar, turnover summary, P&L / books, bank statement',
    payment: { entity_type: 'INCOME_TAX', value: 'BUSINESS' },
  },
  {
    source: 'Profession',
    itr: 'Usually ITR-3 or ITR-4',
    price: 'Price on request',
    docs: 'PAN, Aadhaar, receipts summary, expense details, bank statement',
    payment: { entity_type: 'INCOME_TAX', value: 'PROFESSION' },
  },
  {
    source: 'House Property',
    itr: 'Usually ITR-1 or ITR-2',
    price: 'Price on request',
    docs: 'PAN, Aadhaar, rental details, home loan interest certificate',
    payment: { entity_type: 'INCOME_TAX', value: 'HOUSE_PROPERTY' },
  },
  {
    source: 'Capital Gains',
    itr: 'Usually ITR-2 or ITR-3',
    price: 'Price on request',
    docs: 'PAN, Aadhaar, broker/capital gain statement, sale-purchase details',
    payment: { entity_type: 'INCOME_TAX', value: 'CAPITAL_GAINS' },
  },
  {
    source: 'Other Sources',
    itr: 'Usually ITR-1 or ITR-2',
    price: 'Price on request',
    docs: 'PAN, Aadhaar, interest/dividend/family pension details',
    payment: { entity_type: 'INCOME_TAX', value: 'OTHER_SOURCES' },
  },
  {
    source: 'Multiple Sources',
    itr: 'Based on your mix (ITR-2/3/4)',
    price: 'Price on request',
    docs: 'All relevant proofs for each income source',
    payment: { entity_type: 'INCOME_TAX', value: 'MULTIPLE_SOURCES' },
  },
];
